/* A required code to make i18 language translation initialization work. Needs only to be placed in the src root folder */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "language",
      convertDetectedLanguage: (lng: string) => lng.split("-")[0],
    },
  });

export default i18n;
